<template>
    <div>
        <div class="pa-3" style="display: flex">
            <h1>Dine-In Review Management</h1>
        </div>
        <v-layout row style="margin-bottom: 10px;">
            <v-flex xs12>
                <v-toolbar flat>
                    <v-text-field v-model="search" prepend-icon="search" label="Review text, store name, etc." single-line
                        hide-details style="padding: 0"></v-text-field>
                </v-toolbar>
            </v-flex>
        </v-layout>
        <v-data-table style="border: 1px solid black" :headers="headers" :loading="is_loading_store"
            :items="filteredReviewLists" :pagination.sync="pagination">
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.index + 1 }}</td>

                <td class="text-xs-center">
                    {{ props.item.review_store_name_th }}
                </td>
                <td class="text-xs-center">
                    <v-icon v-for="(item, index) in 5" :key="item.title"
                        :color="calRating(props.item) > index ? 'primary' : '#CCCCCC'" small> mdi-star
                    </v-icon>
                </td>
                <td class="text-xs-center" style="padding-block: 10px; min-width: 160px">
                    <div style="display: flex; justify-content: space-between;">
                        <div>Overall:</div>
                        <div>
                            <v-icon v-for="(item, index) in 5" :key="item.title"
                                :color="props.item.review_overall_rating > index ? 'primary' : '#CCCCCC'" small>
                                mdi-star </v-icon>
                        </div>
                    </div>
                    <div style="display: flex; justify-content: space-between;">
                        <div>Food:</div>
                        <div>
                            <v-icon v-for="(item, index) in 5" :key="item.title"
                                :color="props.item.review_food_rating > index ? 'primary' : '#CCCCCC'" small>
                                mdi-star </v-icon>
                        </div>
                    </div>
                    <div style="display: flex; justify-content: space-between;">
                        <div> Atmosphere:</div>
                        <div><v-icon v-for="(item, index) in 5" :key="item.title"
                                :color="props.item.review_atmosphere_rating > index ? 'primary' : '#CCCCCC'" small>
                                mdi-star </v-icon></div>
                    </div>
                    <div style="display: flex; justify-content: space-between;">
                        <div> Service:</div>
                        <div><v-icon v-for="(item, index) in 5" :key="item.title"
                                :color="props.item.review_serves_rating > index ? 'primary' : '#CCCCCC'" small>
                                mdi-star </v-icon></div>
                    </div>
                    <div style="display: flex; justify-content: space-between;">
                        <div> Valuable:</div>
                        <div> <v-icon v-for="(item, index) in 5" :key="item.title"
                                :color="props.item.review_valuable_rating > index ? 'primary' : '#CCCCCC'" small>
                                mdi-star </v-icon></div>
                    </div>

                </td>
                <td class="text-xs-center" style="padding: 15px; max-width:80px;">
                    <span>
                        {{ props.item.review_text == "" ? '-' : props.item.review_text }}
                    </span>
                </td>
                <td style="display: flex; justify-content: center; margin-top: 25px">
                    <div>
                        <v-switch v-model="props.item.review_status" color="primary"
                            @change="changeState(props.item)"></v-switch>
                    </div>
                </td>

            </template>

            <template slot="no-data">
                <div v-if="dinein_review_list.length == 0 && is_loading_store != true">
                    No data available
                </div>
                <div v-else class="text-xs-center">
                    <v-progress-circular :size="30" color="primary" indeterminate></v-progress-circular>
                    {{ is_loading_store == true ? "Loading data ..." : is_loading_store }}
                </div>
            </template>
        </v-data-table>
        <v-dialog v-model="error_dialog" persistent max-width="500">
        <v-card>
          <div
            style="
              background-color: #fddf00;
              height: 60px;
              display: flex;
              align-items: center;
              padding-left: 20px;
            "
          >
            <v-icon large style="margin-right: 10px" color="black"
              >warning</v-icon
            >
            <div style="font-size: 1.8rem">Warning</div>
          </div>
          <v-card-title class="headline" primary-title> Something went wrong, please try again. </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat @click="error_dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
export default {
    data: () => ({
        is_loading_store: false,
        error_dialog: false,
        all_reviews: [],

        pagination: {
            page_size: 100,
            page: 1,
            totalItems: 0,
        },
        search: "",
        headers: [
            {
                text: "No.",
                align: "center",
                sortable: false,
            },
            {
                text: "Store Name TH",
                align: "center",
                value: "review_store_name_th",
                sortable: false,
            },
            {
                text: "Average Rating",
                align: "center",
                value: "",
                sortable: false,
            },
            {
                text: "Rating",
                align: "center",
                value: "",
                sortable: false,
            },
            {
                text: "Review Text",
                align: "center",
                value: "review_text",
                sortable: false,
            },
            {
                text: "Review Visible",
                align: "center",
                value: "store_status",
                sortable: false,
            },
        ],
    }),
    computed: {
        ...mapState({
            dinein_review_list: (state) => state.fetchDineIn.review_list,
            provinceData: (state) => state.fetchProvinceBack.provinceData,
        }),
        pages() {
            if (this.dinein_review_list.length != 0) {
                this.pagination.totalItems = this.dinein_review_list.length;
            }
            if (
                this.pagination.page_size == null ||
                this.pagination.totalItems == null
            )
                return 0;

            return Math.ceil(this.pagination.totalItems / this.pagination.page_size);
        },
        filteredReviewLists() {
            return this.all_reviews.filter(
                (val) =>
                    val.review_text
                        .toLowerCase()
                        .includes(this.search.toLowerCase()) ||
                    val.review_store_name_th
                        .toLowerCase()
                        .includes(this.search.toLowerCase()) ||
                    val.review_store_name_en
                        .toLowerCase()
                        .includes(this.search.toLowerCase())
            );
        },
    },

    created() {
        this.fetchData();
    },
    methods: {
        moment,
        async changeState(item) {
            var payload = {
                data: {
                    review_id: item.review_id,
                    review_status: item.review_status == true ? 1 : 0
                },
            };
            console.log(payload.data);
            var res = await this.$store.dispatch(
                "fetchDineIn/changeReviewStatus",
                payload
            );
            if (res == false) {
                item.review_status = !item.review_status;
                this.error_dialog = true;
            }
        },
        calRating(item) {
            var finalRate = 0;
            finalRate = item.review_overall_rating + item.review_food_rating + item.review_atmosphere_rating + item.review_serves_rating + item.review_valuable_rating;
            finalRate = Math.ceil(finalRate / 5);
            return finalRate;
        },
        async fetchData() {
            this.is_loading_store = true;
            this.all_reviews = await this.$store.dispatch(
                "fetchDineIn/getAllDineInReviews",
                {
                    search: "",
                    per_page: 1000000,
                    page: 1,
                }
            );
            this.is_loading_store = false;
        },
    },
};
</script>